import { h, Component } from 'preact';
import { DeviceVariance, ContainerSize } from '@cube/blocks';
import { FinanceSpinner } from '../glyphs';
import { getSecurityStats } from '@os/cloudquote';
import StockDetailsPage from '../stock-details-page';
import StatisticsPhone from './statistics-phone';
import StatisticsDesktop from './statistics-desktop';

export default class StatisticsPanel extends Component {

	componentWillMount() {
		getSecurityStats(this.props.symbol).then((data) => {
			if (data && data.rows && data.rows.length) {
				this.setState({ quote: data.rows[0] });
			}
		});
	}

	render(props, { quote }) {

		if (!quote) {
			return (
				<FinanceSpinner />
			);
		}

		return (
			<StockDetailsPage showCurrencyIndicator {...props}>
				<DeviceVariance phone={false}>
					<ContainerSize height={false}>
						<StatisticsDesktop quote={quote} {...props} />
					</ContainerSize>
				</DeviceVariance>

				<DeviceVariance
					phone={
						<ContainerSize height={false}>
							<StatisticsPhone quote={quote} {...props} />
						</ContainerSize>
					}
				/>
			</StockDetailsPage>
		);
	}
}
